import React, { useEffect, useState } from 'react'
import numeral from 'numeral'
import _, { isNull } from 'lodash'
import moment from 'moment'
import {
 Row, Col, DatePicker,
} from 'antd'
import { useQuery, useLazyQuery } from '@apollo/react-hooks'
import {
 Div, H3, P, Loading, Icon, H4,
} from 'konsys-ui'
import { ChevronDown } from 'lucide-react'
import { theme } from '../../styles/_variables'
import { DRIVER_COMPENSATION } from '../../constants/graphql/query'
import { MYINFO } from '../../constants/graph/query'

const Collapse = ({ compensation }) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <div className='my-4'>
      <Div
        className={`cursor-pointer border-b border-gray-200 px-4 pt-4 pb-3 bg-white ${isOpen ? 'rounded-t-lg' : 'rounded-lg'}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <Row>
          <Col span={8}><p className='text-base pl-3'>{compensation.compensationPeriod}</p></Col>
          <Col span={16}>
            <div className='flex w-full items-center justify-between'>
              <p className='text-base text-center w-full'>{numeral(compensation.compensation).format('0,0.00')}{isOpen}</p>
              <ChevronDown className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''} flex-shrink-0`} />
            </div>
          </Col>
        </Row>
      </Div>
      {
        isOpen && (
          <div className='h-full overflow-hidden bg-white px-4 pt-3 pb-4 space-y-3 rounded-b-lg'>
            <Row gutter={16}>
              <Col span={8}><p className='text-xs font-bold text-left text-[#929497]'>ใบสั่งบรรทุก</p></Col>
              <Col span={8}><p className='text-xs font-bold text-right text-[#929497]'>ส่วนต่างน้ำหนักต้นทางตามเกณฑ์ (กก.)</p></Col>
              <Col span={8}><p className='text-xs font-bold text-right text-[#929497]'>ส่วนต่างน้ำหนักสินค้าปลายทาง (กก.)</p></Col>
            </Row>
            <hr className='my-3 text-mercury' />
            {
              compensation.Shippingorders.map(shippingorder => (
                <Row gutter={16} key={shippingorder.id}>
                  <Col span={8}>
                    <p className='text-xs font-semibold text-black'>{shippingorder.Truck.plateNumber}</p>
                    <p className='text-xs text-cool-grey'>{shippingorder.shippingVolume}/{shippingorder.shippingNumber}</p>
                  </Col>
                  <Col span={8}>
                    <p className={`text-right text-xs ${((shippingorder.startWeightDifference !== 0 || isNull(shippingorder.startWeightDifference)) && shippingorder.Job?.dealType === 'PERWEIGHT') ? 'text-error' : 'text-black'}`}>
                      {
                        shippingorder.Job?.dealType === 'PERTRIP'
                        ? '-'
                        : shippingorder.startWeightDifference !== 0
                          ? shippingorder.startWeightDifference > 0
                            ? `เกิน ${numeral(shippingorder.startWeightDifference).format('0,0.00')}`
                            : `ขาด ${numeral(Math.abs(shippingorder.startWeightDifference)).format('0,0.00')}`
                          : isNull(shippingorder.startWeightDifference) ? 'ไม่มีข้อมูล' : 'พอดี'
                      }
                    </p>
                  </Col>
                  <Col span={8}><p className={`text-right text-xs ${((shippingorder.endWeightDifference !== 0 || isNull(shippingorder.endWeightDifference)) && shippingorder.Job?.dealType === 'PERWEIGHT') ? 'text-error' : 'text-black'}`}>
                      {
                        shippingorder.Job?.dealType === 'PERTRIP'
                        ? '-'
                        : shippingorder.endWeightDifference !== 0
                          ? shippingorder.endWeightDifference > 0
                            ? `เกิน ${numeral(shippingorder.endWeightDifference).format('0,0.00')}`
                            : `ขาด ${numeral(Math.abs(shippingorder.endWeightDifference)).format('0,0.00')}`
                          : isNull(shippingorder.endWeightDifference) ? 'ไม่มีข้อมูล' : 'พอดี'
                      }
                    </p></Col>
                </Row>
              ))
            }
          </div>
        )
      }
    </div>
  )
}

export default () => {
  const [getDriverCompensation, { data, loading }] = useLazyQuery(DRIVER_COMPENSATION)
  const me = useQuery(MYINFO)

  useEffect(() => {
    if (me?.data?.myInfo?.driverId) {
      getDriverCompensation({
        variables: {
          driverId: me?.data?.myInfo?.driverId,
          compensationDate: moment(),
        },
      })
    }
  }, [me?.data?.myInfo])

  return (
    <Div display='flex' flexDirection='column'>
      <Row type='flex' justify='space-between' align='middle'>
        <H3 style={{ alignItems: 'flex-start' }} bold color={theme.color.primaryColor} margin='32px 0'>เบี้ยเลี้ยง</H3>
        <DatePicker.MonthPicker defaultValue={moment()} onChange={(e) => {
          getDriverCompensation({
            variables: {
              driverId: me?.data?.myInfo?.driverId,
              compensationDate: e,
            },
          })
        }} />
      </Row>
      {
        loading
        ? <Loading center='true'/>
        : _.isEmpty(data?.DriverCompensationList?.lists)
          ? <Div display='flex' width='100%' height='300px' justifyContent='center' alignItems='center' flexDirection='column'>
              <Icon margin='16px' fontSize='40px' icon='far fa-empty-set' color={theme.color.heather} />
              <H4 color={theme.color.heather} bold>ไม่พบเบี้ยเลี้ยง</H4>
            </Div>
          : <Div>
              <Row style={{ margin: '0 16px 0', padding: '0 32px 0 0' }}>
                <Col span={8}><p className='text-sm font-bold text-left text-cool-grey'>งวดที่</p></Col>
                <Col span={16}><p className='text-sm font-bold text-center text-cool-grey'>จำนวนเงิน (บาท)</p></Col>
              </Row>
              {
                data?.DriverCompensationList?.lists.map(compensation => (
                  <Collapse key={compensation.id} compensation={compensation} />
                ))
              }
              <Div className='px-4 py-4 rounded-lg' bgColor={`${theme.color.primaryColor}33`}>
                <Row>
                  <Col span={8}><P style={{ width: '100%' }} bold textAlign='left'>รวมทั้งหมด</P></Col>
                  <Col span={16}><P style={{ width: '100%' }} bold textAlign='center' padding='0 24px 0 0'>{numeral(_.sum(data?.DriverCompensationList?.lists.map(compensation => compensation.compensation))).format('0,0.00')}</P></Col>
                </Row>
              </Div>
            </Div>
      }
    </Div>
  )
}
